module.exports = __webpack_public_path__ + "img/shoufei.244445d1.png";